import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import { langList } from '../../../factories/Utils'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import {
  createVenueTag,
  deleteVenueTag,
  updateVenueTag,
} from '../../../store/VenueTagReducer'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const VenueTagForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.venueTag)

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async (values) => {
          const data = new FormData()

          // Ajout des champs multilingues
          const localizedFields = langList.map((lang) => lang.code)
          localizedFields.map((field) => {
            const value = values[field]
            if (value?.name) {
              data.append(field + '[name]', value.name)
            }
          })

          // Ajout du fichier si présent
          if (values.icon && values.icon[0]?.originFileObj) {
            data.append('icon', values.icon[0].originFileObj)
          }

          return dispatch(createVenueTag(data)).then(() => {
            return true
          })
        },
        update: async (values) => {
          const data = new FormData()
          data.append('id', values.id)

          const localizedFields = langList.map((lang) => lang.code)
          localizedFields.map((field) => {
            const value = values[field]
            if (value?.name) {
              data.append(field + '[name]', value.name)
            }
          })

          if (values.icon && values.icon[0]?.originFileObj) {
            data.append('icon', values.icon[0].originFileObj)
          }

          return dispatch(updateVenueTag(data)).then(() => {
            return true
          })
        },
        delete: async (values) =>
          dispatch(deleteVenueTag(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

VenueTagForm.displayName = 'VenueTagForm'

export default VenueTagForm
